<div class="full-height full-width flex column align-center justify-center no-data">
  <h2 class="margin-bottom">
    You are unauthorized
  </h2>
  <h4 class="margin-bottom">You will be redirected in <b>{{timer}}</b>...</h4>
  <img src="assets/back-office/images/not-authorized-dark.svg">
</div>